<template>
    <!--
      作者：bbc_team
      时间：2023-06-08
      描述：平台活动-添加
    -->
    <div class="goods-add pb50">
        <!--添加-->
        <el-form ref="form" size="small" :model="form" :rules="rules" label-width="100px">
            <div class="common-form">添加问答</div>
            <el-form-item label="问题" prop="question">
                <el-input type="textarea" :rows="2" v-model="form.question" placeholder="请输入问题" class="max-w460"></el-input>
            </el-form-item>
            <el-form-item label="答案" prop="answer">
                <Uediter ref="ue2" editor_id="ue2" :text="form.answer" :config="ueditor.config" @contentChange="contentChangeFunc"></Uediter>
            </el-form-item>
            <el-form-item label="排序"><el-input v-model="form.sort" type="number" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
            <!--提交-->
            <div class="common-button-wrapper">
                <el-button size="small" type="info" :loading="loading" @click="cancelFunc">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="onSubmit">提交</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
    import PlatformActivityApi from "@/api/platformactivity.js";
    import Uediter from "@/components/UE.vue";

    export default {
        components: {
            /*编辑器*/
            Uediter,
        },
        data() {
            return {
                /*富文本框配置*/
                ueditor: {
                    text: "",
                    config: {
                        initialFrameWidth: 400,
                        initialFrameHeight: 500
                    }
                },
                /*form表单数据*/
                form: {
                    question_id:"",
                    activity_id:"",
                    question: "",
                    answer: "",
                    sort: 1,
                    status: 1,
                },
                activityData:[],
                loading: false,
                /*验证规则*/
                rules: {
                    activity_id: [{ required: true, message: "请选择活动", trigger: "blur" }],
                    question: [{ required: true, message: "请输入问题", trigger: "blur" }],
                    answer: [{ required: true, message: "请输入答案", trigger: "blur" }]
                }
            };
        },
        created() {
            this.form.activity_id = this.$route.query.activity_id;
            /*获取活动列表*/
            // this.getActivityList();
        },
        methods: {
            /*获取富文本框内容*/
            getContent: function() {
                //return this.$refs.ue.getUEContent();
            },

            /*获取富文本内容*/
            contentChangeFunc(e) {
                this.form.answer = e;
            },

            /*获取活动列表*/
            getActivityList() {
                let self = this;
                let Params = {};

                PlatformActivityApi.activity.list(Params, true)
                    .then((res) => {
                        self.activityData = res.data.list.data;
                    })
                    .catch((error) => {});
            },
            /*添加广告*/
            onSubmit() {
                let self = this;
                let form = self.form;
                self.$refs.form.validate((valid) => {
                    if (valid) {
                        self.loading = true;
                        PlatformActivityApi.question.add(form, true)
                            .then((data) => {
                                self.loading = false;
                                self.$message({
                                    message: data.msg,
                                    type: "success"
                                });

                                //返回上一页
                                self.$router.back()
                            })
                            .catch((error) => {
                                self.loading = false;
                            });
                    }
                });
            },

            /*取消添加，返回列表*/
            cancelFunc() {
                this.$router.back();
            }
        }
    };
</script>

<style>
    .edit_container {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .ql-editor {
        height: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/views/platformactivity/question/add.vue